export const permissionNamesMap = [
  {
    name: 'Calendar',
    value: 'calendar',
  },
  {
    name: 'Statistics',
    value: 'statistics',
  },
  {
    name: 'All Flights',
    value: 'allFlights',
    children: [
      {
        name: 'Arrival comments & Notes',
        value: 'arrivalCommentsAndNotes',
      },
      {
        name: 'Pre Flight Comments',
        value: 'preFlightComments',
      },
      {
        name: 'Post Flight Comments',
        value: 'postFlightComments',
      },
    ],
  },
  {
    name: 'Only Assigned Flights',
    value: 'assignedFlights',
    children: [
      {
        name: 'Arrival comments & Notes',
        value: 'arrivalCommentsAndNotes',
      },
      {
        name: 'Pre Flight Comments',
        value: 'preFlightComments',
      },
      {
        name: 'Post Flight Comments',
        value: 'postFlightComments',
      },
    ],
  },
  {
    name: 'Notes (Visible to Airlines)',
    value: 'notes',
  },
  {
    name: 'Users',
    value: 'users',
  },
  {
    name: 'Staff Assignment',
    value: 'staffAssignment',
  },
];

export const initialPermissionValues = {
  calendar: {
    view: false,
  },
  statistics: {
    view: false,
  },
  allFlights: {
    global: {
      view: false,
      create: false,
      edit: false,
      delete: false,
    },
    children: {
      arrivalCommentsAndNotes: {
        view: false,
        create: false,
        edit: false,
        delete: false,
      },
      preFlightComments: {
        view: false,
        create: false,
        edit: false,
        delete: false,
      },
      postFlightComments: {
        view: false,
        create: false,
        edit: false,
        delete: false,
      },
    },
  },
  assignedFlights: {
    global: {
      view: false,
      create: false,
      edit: false,
      delete: false,
    },
    children: {
      arrivalCommentsAndNotes: {
        view: false,
        create: false,
        edit: false,
        delete: false,
      },
      preFlightComments: {
        view: false,
        create: false,
        edit: false,
        delete: false,
      },
      postFlightComments: {
        view: false,
        create: false,
        edit: false,
        delete: false,
      },
    },
  },
  notes: {
    view: false,
    create: false,
    edit: false,
    delete: false,
  },
  users: {
    view: false,
    create: false,
    edit: false,
    delete: false,
  },
  staffAssignment: {
    view: false,
    create: false,
    edit: false,
    delete: false,
  },
};
